import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Stack, Typography, SxProps, Theme } from '@mui/material'
import { FieldError } from 'react-hook-form'
import { colorPalette } from '~/constants/styles/colors'

type ValidationErrorMessageProps = {
  error: FieldError | string | undefined
  sx?: SxProps<Theme>
}

export const ValidationErrorMessage: React.FC<ValidationErrorMessageProps> = ({ error, sx }) => {
  if (!error) return

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} pt={0.5} sx={{ color: colorPalette.error.main, ...sx }}>
      <HighlightOffIcon fontSize="small" />
      <Typography variant="body2">{typeof error === 'string' ? error : error.message}</Typography>
    </Stack>
  )
}
